<template>
	<BaseLayout :footer-full="true" :include-padding="false" :transparent-header="true">
		<ProHero />
		<MoreHandsOnSection />
		<ImportantDetailsSection />
	</BaseLayout>
</template>

<script setup lang="ts">
import ImportantDetailsSection from '@components/marketing-site/fundrise-pro/important-details-section.vue';
import MoreHandsOnSection from '@components/marketing-site/fundrise-pro/more-hands-on-section.vue';
import ProHero from '@components/marketing-site/fundrise-pro/pro-hero.vue';
</script>
